<template>
    <div>
        <div class="bg-white border-bottom" style="border-top: 30px solid #06a9d8 !important;">
            <div class="container py-4">
                <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <h3 class="font-weight-bold mb-1">Job Application Form</h3>
                        <small class="text-muted">Hextar — Employment Application</small>
                    </div>
                    <img
                        src="https://getasia.s3.ap-southeast-1.amazonaws.com/images/hextar_logo.png"
                        style="height: 58px; width: auto;"
                        alt="Hextar"
                    >
                </div>
            </div>
        </div>
        <div class="bg-light py-4">
            <div class="container">
                <div class="card shadow-sm mb-3">
                    <div class="card-body text-center py-5">
                        <i class="mdi mdi-checkbox-marked-circle text-success display-4"></i>
                        <h4 class="font-weight-bold mt-3">Application Submitted</h4>
                        <p class="text-muted mb-0">Your application has been submitted successfully. Thank you for your application.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    page: {
        title: "Application Submitted",
    },
}
</script>
